// PROD-9786: pure labels for the session History modal on /trial_points/:teacher_uuid.

const TYPE_LABELS = {
  consumed: 'Charged',
  refunded: 'Refunded',
  conversion_1on1: 'Conversion (1on1)',
  conversion_gc: 'Conversion (GC)',
  cms_add: 'Added by care team',
  cms_remove: 'Removed by care team',
  initial: 'Initial grant'
};

const ACTOR_LABELS = { CMS_USER: 'Care team', TEACHER: 'Teacher', SYSTEM: 'System' };

export function history_event_label(ev) {
  if (!ev) return '';
  if (ev.kind === 'ban') return 'Student banned';
  if (ev.kind === 'unban') return 'Student unbanned';
  return TYPE_LABELS[ev.type] || ev.type || '';
}

export function history_points_text(ev) {
  if (!ev || ev.points === undefined || ev.points === null) return '';
  return ev.points > 0 ? `+${ev.points}` : `${ev.points}`;
}

// Who did it: the resolved name, else the actor kind ("Care team", "Teacher").
export function history_actor_text(ev) {
  if (!ev || !ev.by) return '';
  const role = ACTOR_LABELS[ev.by] || ev.by;
  return ev.by_name ? `${role} · ${ev.by_name}` : role;
}

// The charge's matrix row and multiplier, e.g. "finished ×1.25 · lead score 6".
export function history_pricing_text(ev) {
  if (!ev) return '';
  const parts = [];
  if (ev.deduction_outcome) {
    parts.push(ev.multiplier ? `${ev.deduction_outcome} ×${ev.multiplier}` : ev.deduction_outcome);
  }
  if (ev.lead_score !== undefined && ev.lead_score !== null) {
    parts.push(`lead score ${ev.lead_score}`);
  }
  return parts.join(' · ');
}

export function history_exception_text(ex) {
  if (!ex) return '';
  const what = ex.is_waived === 1 ? 'Waived' : `Custom charge ${ex.custom_charge}`;
  return ex.updated_by_name ? `${what} · ${ex.updated_by_name}` : what;
}

// History icon only after a change: a second consume/refund row, a conversion, a ban or an exception.
export function has_history_changes(row) {
  if (!row) return false;
  return (
    (row.ledger_rows || 0) > 1 ||
    Boolean(row.conversion_points) ||
    Boolean(row.student_banned) ||
    Boolean(row.exception_reason)
  );
}
